<template>
  <reports-survey template-id="OpinionSurvey" />
</template>
<script>
import ReportsSurvey from "./ReportsSurvey";
export default {
  name: "ReportsOpinionSurvey",
  components: { ReportsSurvey },
};
</script>
